export enum StatusEnum{
  FIRE_WARNING = "apiFireWarning",
  ALARM_WARNING = "apiAlarmWarning",
  GEOFENCE_WARNING = "apiGeofenceWarning",
  SELF_CHECK_WARNING = "apiSelfCheckWarning",
  OUT_OF_BED_WARNING = "apiOutOfBedWarning",
  FRIDGE_WARNING = "apiFridgeWarning",
  IN_BED_WARNING = "apiInBedWarning",
  OUT_OF_BATTERY_WARNING = "apiOutOfBatteryWarning",
  OFFLINE_WARNING = "apiOfflineWarning",
  TCP_STATUS_DISABLED_WARNING = "apiTcpStatusDisabledWarning",
  OUTDATED_POSITION_WARNING = "apiOutdatedPositionWarning",
  BATTERY_WARNING = "apiBatteryWarning",
  INACTIVE_WARNING = "apiInactiveWarning",
  GENERAL_WARNING = "apiGeneralWarning",
  LOW_SENSOR_BATTERY = "apiLowSensorBattery",
  NEVER_USED = "apiNeverUsed",
  OK = "apiOkStatus"
};